import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileDocument, FileDocumentPage } from '../models/document.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DocumentService {
  private base = `${environment.apiUrl}/api/v2`;

  constructor(private http: HttpClient) {}

  /**
   * Liste paginée avec filtres.
   * @param category  'document' | 'rapport_annuel' | '' (tous)
   * @param search    recherche textuelle
   * @param page      numéro de page (1-based)
   * @param perPage   éléments par page
   */
  getFiles(
    category: string = '',
    search: string = '',
    page: number = 1,
    perPage: number = 12,
  ): Observable<FileDocumentPage> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);
    if (category) params = params.set('category', category);
    if (search && search.trim()) params = params.set('search', search.trim());
    return this.http.get<FileDocumentPage>(`${this.base}/files`, { params });
  }

  /** Détail d'un fichier */
  getFile(id: number): Observable<{ data: FileDocument }> {
    return this.http.get<{ data: FileDocument }>(`${this.base}/files/${id}`);
  }
}
